import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IMaterial } from '@interfaces/IMaterial';
import { Params } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class MaterialsService {
  constructor(private _http: HttpClient) {}

  createMaterial(material: FormData): Observable<IMaterial> {
    const url = `${environment.baseUrl}api/v1/materials/`;
    return this._http.post<IMaterial>(url, material);
  }

  getMaterial(id: number): Observable<IMaterial> {
    const url = `${environment.baseUrl}api/v1/materials/${id}/`;
    return this._http.get<IMaterial>(url);
  }

  deleteMaterial(id: number): Observable<null> {
    const url = `${environment.baseUrl}api/v1/materials/${id}/`;
    return this._http.delete<null>(url);
  }

  updateMaterial(material: {
    id?: number;
    group_id?: number;
    content: string;
    title?: string;
  }): Observable<IMaterial> {
    const url = `${environment.baseUrl}api/v1/materials/${material.id}/`;
    return this._http.put<IMaterial>(url, material);
  }

  getMaterials(
    groupId?: number | null,
    queries?: Params
  ): Observable<{ count: number; results: IMaterial[] }> {
    let url = `${environment.baseUrl}api/v1/materials/`;
    if (groupId) {
      url += `?group_id=${groupId}`;
    }
    if (queries) {
      url += `?`;
      Object.keys(queries).forEach(key => {
        url += `${key}=${queries[key]}&`;
      });
    }
    return this._http.get<{ count: number; results: IMaterial[] }>(url);
  }
}
